$(document).ready(function(){
    console.log("On Ready");
});

// $(document).ready(function(){
//   $('section.reserve-section .btn-box a.theme-btn').click(function(e){
//     // e.preventDefault();
//     $('.custom_liquid > div > span').trigger("click");
//     console.log("Trigered");
//   });
// });
